import React, { useEffect,useState } from "react"
import "./GameCard.scss"
import RatingYellow from "./../assets/icons/complete.png"
import {Link} from "react-router-dom"
import { logEvent } from "../Analytics/AnalyticsEvent"
import { screen } from '../Analytics/EventName';
import { reactLocalStorage } from "reactjs-localstorage"
import btnLink from "./../assets/icons/play-btn.png";
import {FaPlay} from "react-icons/fa";


function GameCard(props) {
    const {data,btn_color,color,play_btn_txt} = props
    console.log("btn_color:",color)
    console.log("inside gameCard component",data)
    
  return (
    <div className="card-bg mb-3" >
         <div className="card-content p-0">
                <div className="gamecard-wrapper">
                    <div>
                    <figure className="image is-120x120 lazy-image">
                            <img src={data.gameImage} alt={data.gameName} className=" img-radius"/>
                        </figure>
                    </div>
                    <div className="p1">
                    <p className="title is-capitalized is-6 text-white text-left" style={{whiteSpace:"break-spaces"}}>{data.gameName}</p>
                    <div className="gamecard-wrapper">
                        <div className="">
                        <p className="title is-capitalized is-6 text-white">{data.gamePlayed}</p>
                        <div className="text-left mr">
                            <img src={RatingYellow} className="star-icon rating-icon" />
                            <small className="" style={{marginTop:0}}>{data.ratings}</small>
                        </div>
                        </div> 
                        <div style={{position: "absolute",right: "-1.25rem"}}>
                        <Link to={`/game/${data.category}/${data.id}`}  
                        onClick={() => {
                            console.log("data.gameName", data.gameName + "_cardClick")
                            logEvent(
                                {
                                    screen: screen.categoryPage,
                                    event : data.id + "_cardClick"
                                },
                                {
                                    gameId : data.id,
                                    uid : reactLocalStorage.get('uid')? reactLocalStorage.get('uid'):"NA",
                                });

                        }}>
                            <div className="playBtn display"><FaPlay color={btn_color} className="m-auto"/><span  className="m-auto align" style={{color:color}}>{play_btn_txt}</span> </div>                        
                            </Link>
                        </div>
                    </div>
                    </div>
                </div>
         </div>
    </div>
  )
}
    
export default GameCard